import { Injectable } from '@angular/core';
import { AbstractControl, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  constructor() {}

  //Validators
  containsSpace(control: FormControl): ValidationErrors | null {
    if (control.value != null && control.value.indexOf(' ') != -1) {
      return { containsSpaceError: true };
    }
    return null;
  }

  birthdayPattern(control: FormControl): ValidationErrors | null {
    const pattern = /^[\d]{2}.[\d]{2}.[\d]{4}$/;
    if (control.value != null && !control.value.match(pattern)) {
      return { birthdayPattern: true };
    }
    return null;
  }

  emailPattern(control: FormControl): ValidationErrors | null {
    const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    if (control.value != null && !pattern.test(control.value)) {
      return { emailPattern: true };
    }
    return null;
  }

  shortPassword(control: AbstractControl): ValidationErrors | null {
    if (control.value != null && control.value.length < 8) {
      return { shortPassword: true };
    } else return null;
  }
  noSpecialCharacters(control: AbstractControl): ValidationErrors | null {
    const characterList: string[] = [
      '!',
      '@',
      '$',
      '%',
      '&',
      '/',
      '(',
      ')',
      '=',
      '?',
      '*',
      '+',
      '#',
      '-',
      '_',
      "'",
      '[',
      ']',
      '{',
      '}',
      '^',
      ' ',
      '~',
    ];
    var containsCharacter: Boolean = false;
    if (control.value != null) {
      characterList.forEach((character) => {
        if (control.value.includes(character)) {
          containsCharacter = true;
        }
      });
    }
    return containsCharacter === true ? null : { noSpecialCharacters: true };
  }

  uppercase(control: AbstractControl): ValidationErrors | null {
    const pattern = /[A-Z]/;
    if (control.value != null && !pattern.test(control.value)) {
      return { uppercase: true };
    } else return null;
  }

  lowercase(control: AbstractControl): ValidationErrors | null {
    const pattern = /[a-z]/;
    if (control.value != null && !pattern.test(control.value)) {
      return { lowercase: true };
    } else return null;
  }

  number(control: AbstractControl): ValidationErrors | null {
    const pattern = /\d/;
    var test = control.value != null && !pattern.test(control.value)
    if (control.value != null && !pattern.test(control.value)) {
      return { number: true };
    } else return null;
  }

  passwordMatch(control: AbstractControl): ValidationErrors | null {
    const password: string = control.parent?.get('password')?.value;
    const confirmPassword: string = control.value;
    if (password === confirmPassword) {
      return null;
    }
    return { passwordMatch: true };
  }

  noPersianLettersValidator(control: FormControl): ValidationErrors | null {
    const persianPattern = /[\u0600-\u06FF]/; // Unicode range for Persian and arabic characters
    const forbidden = persianPattern.test(control.value);
    return forbidden ? { noPersianLettersValidator: true } : null;
  };
}
